module.exports = __webpack_public_path__ + "000e16e8eb16bbb4ce30918b224bdc3d.png";